var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_vm._m(0),_vm._v(" "),(_vm.languages.length === 1)?_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.languages[0])))]):_c('A11y-Dropdown',{attrs:{"dropdown-props":{
      ref:'languageDropdown'
    },"button-props":{
      type:'button',
      class:'btn btn-sm btn-gb-light dropdown-toggle',
      role:'combobox',
      'aria-haspopup':'listbox',
      id:'language-dropdown-button-'+_vm.htmlId,
      'aria-controls':'language-dropdown-menu-'+_vm.htmlId,
      'aria-label':_vm.triggerAriaLabel
    },"dom-attributes":{
      role:'listbox',
      id:'language-dropdown-menu-'+_vm.htmlId
    }},on:{"openedDropdown":_vm.changedLanguage}},[_c('template',{slot:"button-contents"},[_vm._v("\n      "+_vm._s(_vm._f("capitalize")(_vm.displayLanguage))+"\n      "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('template',{slot:"dropdown-items"},_vm._l((_vm.languages),function(language){return _c('li',{key:language,attrs:{"role":"presentation"}},[_c('a',{attrs:{"role":"option","aria-selected":language === _vm.displayLanguage ? 'true' : 'false'},on:{"click":function($event){return _vm.selectLanguage(language)}}},[_vm._v(_vm._s(_vm._f("capitalize")(language)))])])}),0)],2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"gb-text-base",attrs:{"for":"language-select"}},[_c('i',{staticClass:"fa fa-globe",attrs:{"aria-hidden":"true"}}),_vm._v(" Assessment Language: ")])
}]

export { render, staticRenderFns }